import { EffortType } from "shared/constants/effortTypes";

export type ContractType = "Evaluation" | "Licensing" | "Internal" | "Custom";

export type AppComponentName = string;

export type QuotaPeriod = "Month" | "Year";

export interface ComponentQuota {
  enabled: boolean;
  quotaAmount?: number;
  effortType?: EffortType;
  period?: QuotaPeriod;
  startDate?: Date | null;
  endDate?: Date | null;
}

export interface ComponentAccessItem {
  name: AppComponentName;
  value: boolean;
  sdkAccess: boolean;
  componentQuotas?: ComponentQuota[];
}

export type AppEnvironmentName = "prod" | "staging" | "collab" | "dev";

export interface EnvAccessItem {
  name: AppEnvironmentName;
  value: boolean;
}

export interface Group {
  _id: string;
  name: string;
  description?: string;
  contractType: ContractType;
  lcmProcessId?: string;
  startDate: Date | null;
  endDate: Date | null;
  creationDate: Date | null;
  allowedDomains: string[];
  componentAccess: ComponentAccessItem[];
  envAccess: EnvAccessItem[];
  ownerId: string;
  ownerName: string;
  billingId?: string;
  companyPrefix?: string;
  quotaLimit?: number;
  quotaUsed?: number;
  quotaExpiration?: number;
}

// Maximum length of Group.description, enforced on both the create and the edit form.
export const GROUP_DESCRIPTION_MAX_LENGTH = 250;

export enum GroupStatus {
  active = "active",
  inactive = "inactive",
  expired = "expired",
  expiring = "expiring",
}

export const defaultCreateGroupFormFields = {
  _id: "",
  name: "",
  description: "",
  contractType: "" as ContractType,
  lcmProcessId: "",
  startDate: null,
  endDate: null,
  creationDate: null,
  allowedDomains: [""] as string[],
  componentAccess: [] as ComponentAccessItem[],
  envAccess: [
    { name: "prod", value: false } as EnvAccessItem,
    { name: "staging", value: false } as EnvAccessItem,
    { name: "collab", value: false } as EnvAccessItem,
    { name: "dev", value: false } as EnvAccessItem,
  ],
  ownerId: "",
  ownerName: "",
  billingId: "",
  companyPrefix: "",
};

export enum GroupEditSection {
  none = "none",
  name = "name",
  description = "description",
  contractDetails = "contractDetails",
  allowedDomains = "allowedDomains",
  accessPermissions = "accessPermissions",
}

export enum SortByGroupMenuOptions {
  Alphabetically = "Alphabetically",
  RecentlyAdded = "Recently Added",
}

export interface GroupSortAndFilterOptions {
  filterByStatus: (GroupStatus | string)[];
  filterByContractType: (ContractType | string)[];
  filterByAccessPermissions: string[];
  sortBy: string;
}

export const defaultGroupSortAndFilterOptions: GroupSortAndFilterOptions = {
  filterByStatus: ["All"],
  filterByContractType: ["All"],
  filterByAccessPermissions: ["All"],
  sortBy: SortByGroupMenuOptions.Alphabetically,
};
export type GroupFilterValue = GroupStatus | ContractType | string | "All";

export type AppAccessResponse = {
  appNames: AppComponentName[];
  sdk: boolean;
};

export interface UseGroupFilterByUrlResult {
  selectedGroupId: string | null;
  selectedGroup: Group | null;
  displayedGroups: Group[];
}

export const componentNames: AppComponentName[] = ["TTS"];

export const quotaPeriods: QuotaPeriod[] = ["Month", "Year"];

export type GroupPermissionsSchema = {
  allowedDomains: string[];
  componentAccess?: {
    name: AppComponentName;
    value: boolean;
    sdkAccess: boolean;
    componentQuotas?: ComponentQuota[];
  }[];
};
